import {
    useInView,
    type IntersectionOptions
} from 'react-intersection-observer';

export const InViewMount: React.FC<
    React.PropsWithChildren<{ opts?: IntersectionOptions }>
> = ({ children, opts }) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        fallbackInView: true,
        ...opts
    });
    return <div ref={ref}>{inView && children}</div>;
};
